const INTERNAL_HOSTS = (
  document.querySelector("script[data-internal-domains]")?.dataset
    .internalDomains ?? ""
)
  .split(" ")
  .map((domain) => domain.replace(/^www\./, ""))
  .filter(Boolean);
const EXTERNAL_REL = ["noopener", "noreferrer"];

const isInternalHost = (hostname) =>
  hostname === window.location.hostname ||
  INTERNAL_HOSTS.some(
    (host) => hostname === host || hostname.endsWith(`.${host}`),
  );

const openExternalInNewWindow = (link) => {
  let url;
  try {
    url = new URL(link.href);
  } catch {
    return;
  }
  if (
    (url.protocol !== "http:" && url.protocol !== "https:") ||
    isInternalHost(url.hostname)
  ) {
    return;
  }
  link.setAttribute("target", "_blank");
  const rel = new Set(
    (link.getAttribute("rel") || "").split(/\s+/).filter(Boolean),
  );
  EXTERNAL_REL.forEach((token) => rel.add(token));
  link.setAttribute("rel", [...rel].join(" "));
};

const scan = (root) => {
  if (root.matches?.("a[href]")) {
    openExternalInNewWindow(root);
  }
  root.querySelectorAll?.("a[href]").forEach(openExternalInNewWindow);
};

scan(document);

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "attributes") {
      if (mutation.target.matches("a[href]")) {
        openExternalInNewWindow(mutation.target);
      }
    } else {
      mutation.addedNodes.forEach(scan);
    }
  });
}).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["href"],
});
